import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useFieldHelper } from 'framework/ui/field';

const IssuesStaffingDashboardField = () => {
  const { getValue } = useFieldHelper<any[]>({ source: 'staffingRisk.issues' });
  const issues = getValue() || [];

  return (
    <Stack>
      <Typography variant="body1" color="error">
        {issues[0]?.description || ''}
      </Typography>
      {issues.length > 1 && (
        <Typography variant="caption" color="error">{`...and ${issues.length - 1} more`}</Typography>
      )}
    </Stack>
  );
};

export default IssuesStaffingDashboardField;
